import { render, staticRenderFns } from "./IntermediateLayout.vue?vue&type=template&id=018c924a&"
import script from "./IntermediateLayout.vue?vue&type=script&lang=js&"
export * from "./IntermediateLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports